import { Link } from 'react-router-dom';
import { Button, Result } from 'antd';

/**
 * Страница для несуществующих маршрутов. До её появления неизвестный URL
 * (например, `/admin/audit` вместо `/admin/activity`) рендерил пустой
 * `<main>` без какого-либо сообщения.
 */
export function NotFoundPage(): JSX.Element {
  return (
    <Result
      status="404"
      title="404"
      subTitle="Страница не найдена"
      data-testid="not-found"
      extra={
        <Link to="/">
          <Button type="primary">На главную</Button>
        </Link>
      }
    />
  );
}
